import Code from '@ably/ui/core/Code';
import React from 'react';
import T from 'prop-types';

function highlightLanguageCode(lang = 'bash') {
  let id;

  switch (lang.toLowerCase()) {
    case 'android':
      id = 'java';
      break;

    case '.net':
    case 'net':
    case 'dotnet':
    case 'csharp':
      id = 'cs';
      break;

    case 'objc':
      id = 'obj-c';
      break;

    case 'laravel':
      id = 'php';
      break;

    case 'flutter':
      id = 'dart';
      break;

    default:
      break;
  }

  return id || lang;
}

export default function CodeSnippet({ current }) {
  const { lang, code } = current;
  const id = highlightLanguageCode(lang);
  return (
    <div className="ui-code-explorer-code-content">
      <Code language={id} snippet={code} />
    </div>
  );
}

CodeSnippet.propTypes = {
  current: T.object,
};
